// Global error handler for uncaught exceptions

(function () {
    let errors = [];

    function send() {
        if (errors.length === 0) {
            return;
        }
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-requested-with': 'XMLHttpRequest'
            },
            body: JSON.stringify(errors)
        };
        errors = [];
        fetch('/on/demandware.store/Sites-johnnywas-Site/default/FELogger-Report', options);
    }

    function getDebounceSend() {
        let timer = null;
        return function () {
            if (timer) return;
            timer = setTimeout(function () {
                send();
                timer = null;
            }, 500);
        };
    }

    let debouncedSend = getDebounceSend();

    function log(type, message, line, column, e) {
        errors.push({
            type: type,
            message: message,
            url: window.location.href,
            line: line,
            column: column,
            stack: e && e.stack
        });
        debouncedSend();
    }

    window.onerror = function (message, url, line, column, e) {
        log('window.onerror', message, line, column, e);
        return false;
    };
})();

